export const selectProfile = (state) => state.profile;

export const selectUserProfile = (state) => selectProfile(state).userProfile;
export const selectApplicationProfile = (state) =>
  selectProfile(state).applicationProfile;
export const selectProfileIsFetching = (state) =>
  selectProfile(state).isFetching;
export const selectProfileError = (state) => selectProfile(state).error;
